import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useTheme } from "@mui/material";

import { generateUniqueString } from "../../../../utils/Utils";
import { setStoreData, setIsSceneUpdated, setUnsavedModifications } from "../../../../store/actions/Store";
import { toggleMessageClose, toggleMessageOpen } from "../../../../store/actions/Message";
import store from "../../../../store";


import { getScale } from "../../../../utils/Utils";
import * as SVG from 'svg.js';
import { useTranslation } from "react-i18next";

const createBox = ({ x, y }, { w, h }, type) => {
    const box = document.createElement('div');
    box.id = 'dragBox';
    box.style.lineHeight = '0';
    box.style.position = 'absolute';
    box.style.left = `${x - 1}px`;
    box.style.top = `${y - 1}px`;
    box.style.width = `${w}px`;
    box.style.height = `${h}px`;
    box.style.zIndex = '9999';
    box.style.backgroundColor = '#00ff00';
    box.style.cursor = type == 'horizontal' ? 'col-resize' : 'row-resize'

    return box;
}

const HorizontalLines = (props) => {
    const { ox, scale, stw, handleCreateRuler } = props;
    const [lines, setLines] = useState(null);

    useEffect(() => {
        if(stw) {
            let result = [];

            for(let i = 0; i <= stw; i += 10) {
                result.push(i);
            }

            setLines(result);
        }
    }, [stw, scale]);

    return (
        <>
            {lines && (
                lines.map((value, index) => (
                    <HorizontalLine
                        position={(Number(ox) + value * scale)}
                        value={value}
                        scale={scale}
                        handleCreateRuler={handleCreateRuler}
                        stw={stw}
                    />
                ))
            )}
        </>
    );
}

const VerticalLines = (props) => {
    const { oy, scale, std, handleCreateRuler } = props;
    const [lines, setLines] = useState(null);

    useEffect(() => {
        if(std) {
            let result = [];

            for(let j = 0; j <= std; j += 10) {
                result.push(j);
            }

            setLines(result);
        }
    }, [std]);

    return (
        <>
            {lines && (
                lines.map((value, index) => (
                    <VerticalLine
                        position={(Number(oy) + value * scale)}
                        value={value}
                        scale={scale}
                        handleCreateRuler={handleCreateRuler}
                        std={std}
                    />
                ))
            )}
        </>
    );
}

const HorizontalLine = (props) => {
    const { value, position, scale, handleCreateRuler, stw } = props;
    const theme = useTheme();
    const [step, setStep] = useState(100);

    useEffect(() => {
        if (scale < 0.3 /*&& scale > 0.1*/) {
            setStep(1000);
        } /*else if (scale <= 0.1) {
            setStep(5000);
        }*/ else {
            setStep(100);
        }
    }, [scale]);

    let withValue = value % step == 0;

    if(value == stw) {
        withValue = true;
    }

    const styleWrapper = {
        display: 'inline-block',
        width: 10 * scale + 'px',
        height: 35,
        top: 0,
        position: 'absolute',
        left: Number(position) + 35 + 'px',
        cursor: 'pointer'
    };

    const style = {
        //display: value % (step / 10) == 0 ? 'block' : 'none',
        display: 'block',
        width: '100%',
        height: withValue ? '35px' : '5px',
        top: withValue ? 0 : 30,
        position: 'absolute',
        borderLeft: '1px solid '+(value == 0 ? theme.palette.background.button : theme.palette.text.primary),
    }

    return (
        <span
            id={'horizontal_'+value}
            className="ruler-line-wrapper"
            style={styleWrapper}
            onMouseDown={(event) => handleCreateRuler(value, 'horizontal', event)}
        >
            <span style={style}>
                {withValue && value}
            </span>
        </span>
    );
}

const VerticalLine = (props) => {
    const { value, position, scale, handleCreateRuler, std } = props;
    const theme = useTheme();
    const [step, setStep] = useState(100);

    useEffect(() => {
        if (scale < 0.3 /*&& scale > 0.1*/) {
            setStep(1000);
        }/* else if (scale <= 0.1) {
            setStep(5000);
        }*/ else {
            setStep(100);
        }
    }, [scale]);

    let withValue = value % step == 0;

    if(value == std) {
        withValue = true;
    }

    const styleWrapper = {
        display: 'block',
        width: 35,
        left: 0,
        height: 10 * scale + 'px',
        position: 'absolute',
        top: Number(position) + 35 + 'px',
        cursor: 'pointer'
    };

    const style = {
        //display: value % (step / 10) == 0 ? 'block' : 'none',
        display: 'block',
        height: '100%',
        width: withValue ? '35px' : '5px',
        left: withValue ? 0 : 30,
        position: 'absolute',
        borderTop: '1px solid '+(value == 0 ? theme.palette.background.button : theme.palette.text.primary),
    }

    return (
        <span
            id={'vertical_'+value}
            className="ruler-line-wrapper"
            style={styleWrapper}
            onMouseDown={(event) => handleCreateRuler(value, 'vertical', event)}
        >
            <span style={style}>
                {withValue && value}
            </span>
        </span>
    );
}

function RulerHelper(props)
{
    const { panZoomState, stw, std } = props;

    const theme = useTheme();
    const { t } = useTranslation();
    const storeData = useSelector((state) => state.store.storeData);

    const isAllowed = (x, y, type) => {
        let status = true;

        if(type == 'horizontal' && (x > stw || x < 0)) {
            status = false;
        }

        if(type == 'vertical' && (y > std || y < 0)) {
            status = false;
        }

        if(!status) {
            store.dispatch(toggleMessageOpen(t("Help line can't be placed outside the floor plan!"), 'error'));
        }

        return status;
    }

    const helpLineDropped = (e, svgWrap, type, scale) => {
        document.onmousemove = null;
        svgWrap.onmouseup = null;
    
        document.body.removeChild(svgWrap);

        const clientRectangleH = document.getElementById("horizontal_0").getBoundingClientRect();
        const clientRectangleV = document.getElementById("vertical_0").getBoundingClientRect();

        let x = ((e.pageX - clientRectangleH.left) / scale).toFixed(2);
        let y = ((e.pageY - clientRectangleV.top) / scale).toFixed(2);
        
        if(! isAllowed(x, y, type)) {
            return;
        }

        const ruler = {
            elementType: 'ruler',
            generated_id: generateUniqueString(),
            id: null,
            type: type == 'horizontal' ? 'vertical' : 'horizontal',
            x: type == 'horizontal' ? x : -2147483647,
            y: type == 'vertical' ? y : -2147483647,
        };
        
        const clone = storeData;
        clone.rulers.push(ruler);

        //setRulers(clone.rulers);
        store.dispatch(setStoreData(clone));

        store.dispatch(setIsSceneUpdated(true));
        store.dispatch(setUnsavedModifications(true));
    }

    const handleCreateRuler = (value, type, event) => {
        event.preventDefault();
        event.stopPropagation();

        const clientRectangle = document.getElementById("vertical_0").getBoundingClientRect();

        const w = type == 'horizontal' ? 3 : 2147483647;
        const h = type == 'vertical' ? 3 : 2147483647;
        const x = type == 'horizontal' ? event.pageX : clientRectangle.left;
        const y = type == 'vertical' ? event.pageY : 0;
        const scale = getScale('ElementsLayer');
        const svgWrap = createBox( { x: x, y: y }, { w, h }, type );

        document.body.appendChild(svgWrap);

        SVG(svgWrap.id)
            .viewbox(0, 0, w, h)
            .rect(w, h)
            .fill('#00ff00')
            .style(Object.assign({stroke: 'rgba(0,0,0,0.33)', 'stroke-width': '3', cursor: 'none' }));

        document.onmousemove = e => {
            if (type == 'horizontal') {
                const clientRectangleH = document.getElementById("horizontal_0").getBoundingClientRect();
                let x = ((e.pageX - clientRectangleH.left) / scale).toFixed(2);
                
                if(x <= 0 || x >= stw) {
                    //helpLineDropped(e, svgWrap, type, scale);

                    //return false;
                }

                svgWrap.style.left = `${e.pageX - 1}px`;
            }

            if (type == 'vertical') {
                const clientRectangleV = document.getElementById("vertical_0").getBoundingClientRect();

                let y = ((e.pageY - clientRectangleV.top) / scale).toFixed(2);

                y = y > 0 ? y : 0;
                
                if(y <= 0 || y >= std) {
                    //helpLineDropped(e, svgWrap, type, scale);

                    //return false;
                }

                svgWrap.style.top = `${e.pageY - 1}px`;
            }
        };

        svgWrap.onmouseup = e => {
            helpLineDropped(e, svgWrap, type, scale);
        }
    }

    return (
        <div style={{position: 'absolute', width: '100%', height: '100%'}}>
            <div style={{
                    width: 'calc(100% - 35px)',
                    marginLeft: '35px',
                    height: '35px'
                }}
            >
                <HorizontalLines
                    ox={panZoomState.ox}
                    scale={panZoomState.s}
                    stw={stw}
                    handleCreateRuler={handleCreateRuler}
                />
            </div>
            <div style={{width: '35px', height: 'calc(100% - 35px)'}}>
                <VerticalLines
                    oy={panZoomState.oy}
                    scale={panZoomState.s}
                    std={std}
                    handleCreateRuler={handleCreateRuler}
                />
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    width: '35px',
                    height: '35px',
                    backgroundColor: localStorage.getItem('currentTheme') == 'Dark' ? '#1E2433' : '#FFFFFF',
                    borderRight: '1px solid '+theme.palette.border.main,
                    borderBottom: '1px solid '+theme.palette.border.main
                }}
            >
                &nbsp;
            </div>
        </div>
    )
}

export default RulerHelper;